import React from 'react';
import { Modal } from 'react-bootstrap';
import '../../../assets/css/dashboard.css';
import DownloadReportForm from '../../../components/widgets/forms/setup/DownloadReportForm';

const DownloadReport = ({ show, onHide, commissionId }) => {
  return (
    <div>
      <Modal
        show={show}
        onHide={onHide}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey text-center">Download Report</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DownloadReportForm commissionId={commissionId} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default DownloadReport;